import { useNavigate } from "react-router-dom";

export const BackButton = ({
  children = "Back",
  className,
  ...props
}: {
  children?: React.ReactNode;
  className?: string;
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <button
      {...props}
      className={`u-bg-transparent u-text-black u-border-2 u-border-teal-green u-border-solid u-rounded u-cursor-pointer u-px-4 u-w-full ${
        className ?? ""
      }`}
      onClick={(): void => {
        navigate(-1);
      }}
    >
      <>{children}</>
    </button>
  );
};
